export default "__VITE_ASSET__COre0jXm__"